import React, {ReactElement} from 'react';

import {StoreProvider} from './store';

export default ({element}: {element: ReactElement}) => {
  return <StoreProvider>{element}</StoreProvider>;
};
